/* eslint-disable */

export const getStrategyBotConstants = {
    GET_STRATEGY_BOT_REQUEST: 'GET_STRATEGY_BOT_REQUEST',
    GET_STRATEGY_BOT_SUCCESS: 'GET_STRATEGY_BOT_SUCCESS',
    GET_STRATEGY_BOT_FAILURE: 'GET_STRATEGY_BOT_FAILURE',
};
